import { selectBuildingInfoByTypeId } from "../../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../../utils/utilBuildings";
import { IdTutorialFocusElement } from "../IdTutorialFocusElement";
import { IdTutorialStep } from "../IdTutorialStep";
import { selectTutorialConfigData } from "../selectors/selectTutorialConfigData";
export var checkTutorialQuestClickStartProduction = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var _a = selectTutorialConfigData(state), tutorialStepConfig = _a.tutorialStepConfig, nextTutorialStepConfig = _a.nextTutorialStepConfig;
    if (tutorialStepConfig.nextStep !== IdTutorialStep.checkNewQuest_clickStartProduction) {
        return undefined;
    }
    if (nextTutorialStepConfig.focusId !== IdTutorialFocusElement.button_start_production) {
        return undefined;
    }
    var hasBuildingId = nextTutorialStepConfig.buildingId !== undefined;
    if (!hasBuildingId) {
        return undefined;
    }
    var focusBuilding = selectBuildingInfoByTypeId(state, nextTutorialStepConfig.buildingId);
    var hasFinishedProduction = utilBuildings.hasFinishedProduction(focusBuilding, state.productionInfo.removedProductions);
    return !hasFinishedProduction ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/checks/checkTutorialQuestClickStartProduction.ts
// module id = 2491
// module chunks = 3